// extracted by mini-css-extract-plugin
export default {"container":"YoutubePreview_container__GDgN+","mobilePreviewWrapper":"YoutubePreview_mobilePreviewWrapper__T-rl-","responsiveYoutube":"YoutubePreview_responsiveYoutube__3g4nu"};